import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Icon, Button, Image, List, Loader } from 'semantic-ui-react';
import hasRESTClient from '../../hocs/has-rest-client';

const descriptionStyle = {
  maxWidth: 290,
  marginTop: 10,
};

const commentsWrapper = {
  height: 200,
  overflowY: 'scroll',
};

const loaderStyle = {
  height: 200,
};

const marginTop20 = {
  marginTop: 20,
  display: 'block',
};

const iconStyle = {
  marginTop: 10,
  marginRight: 20,
  border: 'none',
};

class Comments extends React.Component {
  //
  constructor() {
    super();
    this.state = {
      asset: null,
      comments: [],
      isLoading: true,
      canFetchComments: true,
    };
  }

  async componentDidMount() {
    const { buildRESTClient } = this.props;
    const facebookMediaId = _.get(this.props, 'facebookMediaId');
    const influencerId = _.get(this.props, 'influencer.id');
    await this.loadAsset();
    if (facebookMediaId && influencerId) {
      const apiClient = buildRESTClient({
        baseURL: process.env.REACT_APP_INSTAGRAM_SERVICE_URL,
        hasToken: false,
      });
      const response = await apiClient.get(`/influencer/${influencerId}/media/${facebookMediaId}/comments`);
      this.setState({
        comments: _.get(response, 'data.data.data', []),
        isLoading: false,
      });
    } else {
      this.setState({
        isLoading: false,
        canFetchComments: false,
      });
    }
  }

  loadAsset = async () => {
    const { restClient } = this.props;
    const assetId = _.get(this.props, 'trackedAssetId');
    const asset = await restClient.get(`trackedAssets/${assetId}`);
    this.setState({
      asset: _.get(asset, 'data.data'),
    });
  }

  toggleCommentFavouriteState = async comment => {
    const { restClient } = this.props;
    const assetId = _.get(this.props, 'trackedAssetId');
    const comments = _.get(this.state, 'asset.attributes.featuredComments', []);
    const isFavourited = _.find(comments, ['id', comment.id]);
    let updatedComments = _.clone(comments);
    if (isFavourited) {
      updatedComments = _.reject(updatedComments, ['id', comment.id]);
    } else {
      updatedComments.push(comment);
    }
    await restClient.patch(`trackedAssets/${assetId}`, {
      data: {
        attributes: {
          featuredComments: updatedComments,
        },
      },
    });
    await this.loadAsset();
  }

  render() {
    const { comments, isLoading, asset } = this.state;
    const featuredComments = _.get(asset, 'attributes.featuredComments', []);
    return (
      <div>
        {
          isLoading && <div style={loaderStyle}><Loader style={marginTop20} active content="Loading comments..." /></div>
        }
        {
          !isLoading &&
          <List relaxed="very" style={commentsWrapper}>
            {
              _.map(comments, comment => (
                <List.Item key={_.get(comment, 'id')}>
                  <List.Content floated="right">
                    <Button
                      circular
                      basic="very"
                      icon="favorite"
                      style={iconStyle}
                      color={_.find(featuredComments, ['id', comment.id]) ? 'orange' : 'grey'}
                      onClick={() => this.toggleCommentFavouriteState(comment)}
                    />
                  </List.Content>
                  <List.Content>
                    <List.Header as="span">
                      <b>{_.get(comment, 'username')}</b>
                      {' '}<small>{ moment(_.get(comment, 'timestamp')).format('ddd D MMM hh:mm') }</small>
                    </List.Header>
                    <List.Description style={descriptionStyle}>
                      { _.get(comment, 'text') }
                    </List.Description>
                  </List.Content>
                </List.Item>
              ))
            }
          </List>
        }
      </div>

    );
  }
}

export default hasRESTClient(Comments);



/** WEBPACK FOOTER **
 ** ./src/containers/view-asset-page/comments.js
 **/